// Default environment file - used for local development
// This file is overridden by webpack aliases based on BUILD_ENV
export const environment = {
  production: false,
  staging: false,
  apiUrl: 'http://localhost:3000/api/v2',
  version: '0.1.0'
};